module.exports = __webpack_public_path__ + "e4c288fd182f28b6169f9a97e5f52e11.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/caratScale/1.50ct.png
// module id = 810
// module chunks = 0